<template>
    <div class="content">
        <el-page-header @back="returnHistory">
<!--        <el-page-header @back="pushTypeChange" content="任务编辑">-->
            <div slot="content" style="width:100%;display: flex;justify-content: space-between;align-items: center">
                <p style="margin: 0;">任务：{{ taskName }}</p>
                <el-button type="primary" size="mini" @click="saveTask">保存</el-button>
            </div>
        </el-page-header>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>基础信息</span>
            </div>
            <el-descriptions class="margin-top" :column="3" border>
                <el-descriptions-item label="任务名称">
                    <el-input v-model="taskName" size="small"></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="任务描述" span="2">
                    <el-input v-model="taskDesc" size="small"></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="关联活动">
                    <el-select v-model="activeNo" filterable clearable size="small" placeholder="活动">
                        <el-option v-for="item in activeList"
                                   :key="item.activeNo"
                                   :label="item.activeName"
                                   :value="item.activeNo">
                        </el-option>
                    </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="触发方式">
                    <el-select v-model="taskPushType" clearable size="small" placeholder="消息内容" @change="pushTypeChange">
                        <el-option v-for="item in pushTypeList"
                                   :key="item.key"
                                   :label="item.name"
                                   :value="item.key">
                        </el-option>
                    </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="消息提醒类型">
                    <el-select v-model="taskType" clearable size="small" placeholder="消息提醒类型">
                        <el-option v-for="item in messageNoticeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-descriptions-item>
            </el-descriptions>
        </el-card>
        <el-card class="box-card" v-show="!sendByMallAction">
            <div slot="header" class="clearfix">
                <span>用户组</span>
                <el-button style="float: right; padding: 3px 6px" type="text" @click="choseUserGroup">选择分组</el-button>
                <el-button style="float: right; padding: 3px 6px" type="text" @click="addUserGroup">新建分组</el-button>
                <el-button style="float: right; padding: 3px 0" type="text" @click="addUserGroupWithSQLTemplate">使用SQL模板</el-button>
            </div>
            <div v-show="addUserGroupShow">
                <el-table :data="userGroupData" style="width: 100%">
                    <el-table-column label="标签/规则">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.tagId" @change="tagChange(scope.row)">
                                <el-option
                                    v-for="item in tagList"
                                    :key="item.type"
                                    :label="item.title"
                                    :value="item.type"
                                >
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="条件" width="180">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.tagType">
                                <el-option v-for="item in getRuleList(scope.row.tagType)"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="值">
                        <template slot-scope="scope">
                            <el-input v-if="scope.row.tagType == 1"></el-input>
                            <el-date-picker v-if="scope.row.tagType==2"
                                            type="datetime"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            placeholder="选择日期时间"
                                            align="right"
                                            :picker-options="pickerOptions">
                            </el-date-picker>
                            <el-input-number v-if="scope.row.tagType == 3" :min="1" :max="1000" label="整数"></el-input-number>
                            <el-input-number v-if="scope.row.tagType == 4" :precision="2" :step="0.1" :max="1000" label="两位小数"></el-input-number>
                            <el-select v-if="scope.row.tagType==5" filterable clear placeholder="请选择">
                                <el-option v-for="item in productList"
                                           :key="item.proId"
                                           :label="item.proName"
                                           :value="item.proId">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-show="addSQLTemplateShow">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入SQL" v-model="theSql"></el-input>
            </div>
            <el-row v-show="addUserGroupShow || addSQLTemplateShow">
                <p></p>
                <span>首次筛选用户时间(要早于执行时间，最少1小时):</span>
                <el-date-picker
                    v-model="firstFetchUserTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    default-time="02:00:00">
                </el-date-picker>
                <span v-show="sendByRegular">,每隔</span>
                <el-input-number  v-show="sendByRegular" v-model="fetchUserPeriod" :min="-1" placeholder="1440是一天"></el-input-number>
                <span  v-show="sendByRegular">分钟执行一次(-1是只执行一次)</span>
            </el-row>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>推送内容</span>
                <el-button style="float: right; padding: 3px 6px" type="text" @click="addSmsRich">推送彩信</el-button>
                <el-button style="float: right; padding: 3px 6px" type="text" @click="addSmsContent">推送短信</el-button>
                <el-button style="float: right; padding: 3px 6px" type="text" @click="addWxAction">推送微信ACTION</el-button>
            </div>
            <div v-show="addSmsRichShow">
                <p></p>
                <el-row>
                    <span>梦网彩信模板:</span>
                    <el-select v-model="channelTemplateNo" placeholder="请选择模板" filterable clearable size="medium">
                        <el-option v-for="item in channelTemplateList" :key="item.tplId" :label="item.tplName" :value="item.tplId"></el-option>
                    </el-select>
<!--                    <el-input v-model="channelTemplateNo" placeholder="请输入模板ID" size="medium"></el-input>-->
                </el-row>
                <el-row>
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入不支持彩信的用户的短信内容" v-model="smsContent"></el-input>
<!--                    <span>短连接:</span>-->
<!--                    <el-input v-model="shortLink" placeholder="请输入短连接" size="medium"></el-input>-->
                </el-row>
            </div>
            <div v-show="addSmsContentShow">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入短信内容" v-model="smsContent"></el-input>
            </div>
            <el-row v-show="addSmsContentShow">
                <p></p>
                <span>埋点ID/chan_id:</span>
                <el-input-number v-model="chanId" placeholder="请输入chan_id" size="medium"></el-input-number>
            </el-row>
            <div v-show="addWxActionContentShow">
                <el-select v-model="wxAction" filterable clear placeholder="请选择">
                    <el-option v-for="item in wxActionList"
                               :key="item.key"
                               :label="item.name"
                               :value="item.key">
                    </el-option>
                </el-select>
            </div>
        </el-card>
        <el-card class="box-card" v-show="!sendByMallAction">
            <div slot="header" class="clearfix">
                <span>推送时间</span>
            </div>
            <div>
                <el-row>
                    <span>首次执行时间:</span>
                    <el-date-picker
                        v-model="firstExecTime"
                        type="datetime"
                        placeholder="选择日期时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        default-time="12:00:00">
                    </el-date-picker>
                    <span v-show="sendByRegular">,每隔</span>
                    <el-input-number v-show="sendByRegular" v-model="execPeriod" :min="-1" placeholder="1440是一天"></el-input-number>
                    <span v-show="sendByRegular">分钟执行一次(-1是只执行一次)</span>
                </el-row>
            </div>
        </el-card>

    </div>
</template>
<script>
import {
    getTagList,
    getVipDayInfo,
    setVipDayInfo,
    getAction,
    getActiveForOptionListApi,
    getTaskApi,
    getMyTemplatesList,
    saveTaskApiNew, getTaskParaListApi
} from '../../api/api'

export default {
    data() {
        return {
            taskId:this.$route.query.taskId,
            addUserGroupShow : false,
            addSQLTemplateShow : false,
            addSmsContentShow : false,
            addSmsRichShow : false,
            addWxActionContentShow : false,
            sendByMallAction : false,
            sendByRegular : true,
            channelTemplateList : [],
            userGroupData : [],//用户组数据
            tagList : [],
            ruleList : [],
            productList : [],
            wxActionList : [],
            activeList:[],
            pushTypeList:[],
            messageNoticeList:[{id:1,name:'营销类'},{id:2,name:'通知类'}],
            taskName : '',
            taskDesc : '',
            activeNo : '',
            taskPushType : '',
            taskType : '',
            theSql : '',
            channelTemplateNo : '',
            shortLink : '',
            smsContent : '',
            wxAction : '',
            chanId : '',
            firstExecTime : '',
            execPeriod : 1440,
            firstFetchUserTime : '',
            fetchUserPeriod : 1440,
            /*selectValue: '',
            dialogFormVisible:false,
            form: {
                // startTime: "",
                // endTime: "",
                isEffective: "",
                weekIndex:""
            }*/
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '前天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 2*3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }]
            }
        }
    },
    //挂载时候执行
    mounted() {
        this.initData();
    },
    methods: {
        choseUserGroup() {
            this.$message.error("分组功能暂不可用，请使用SQL模板");
            return;
            this.addSQLTemplateShow = false;
            this.addUserGroupShow = true;
        },
        addUserGroup() {
            this.$message.error("分组功能暂不可用，请使用SQL模板");
            return;
            this.addSQLTemplateShow = false;
            this.addUserGroupShow = true;
            addOneRow();
        },
        addUserGroupWithSQLTemplate(){
            this.addUserGroupShow = false;
            this.addSQLTemplateShow = true;

        },
        addSmsContent(){
            this.addSmsRichShow = false;
            this.addSmsContentShow = true;
            this.addWxActionContentShow = false;
        },
        addSmsRich(){
            this.addSmsRichShow = true;
            this.addSmsContentShow = false;
            this.addWxActionContentShow = false;
        },
        addWxAction(){
            this.addSmsRichShow = false;
            this.addSmsContentShow = false;
            this.addWxActionContentShow = true;
        },
        getRuleList(tagType){
            return this.ruleList.filter(item => item.tagType == tagType);
        },
        initData(){
            /*//查询tag
            getTagList().then((res) => {
                if (res.data.success) {
                    console.log(res.data.value);
                    this.userGroupData = res.data.value;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            });
            //查询rule
            getRuleTypeListApi().then((res) => {
                if (res.data.success) {
                    console.log(res.data.value);
                    // this.userGroupData = res.data.value;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            });*/
            //查询所有option
            // getTagOptions
            // 获取WxAction下拉列表数据
            getAction().then((res) => {
                if (res.data.success) {
                    console.log(res.data.value);
                    this.wxActionList = res.data.value;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            });
            getMyTemplatesList().then((res) => {
                if (res.data.success) {
                    console.log("智齿彩信模板",res.data.value);
                    this.channelTemplateList = res.data.value;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            });
            getActiveForOptionListApi().then((res) => {
                if (res.data.success) {
                    this.activeList=res.data.value;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            });
            getTaskParaListApi().then((res) => {
                if (res.data.success) {
                    this.pushTypeList = res.data.value.pushTypeList;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            });
            if(this.taskId != 0){
                getTaskApi({'taskId':this.taskId}).then((res) => {
                    if (res.data.success) {
                        this.taskName = res.data.value.task.taskName;
                        this.taskDesc = res.data.value.task.taskDesc;
                        this.activeNo = res.data.value.task.activeNo;
                        this.taskPushType = res.data.value.task.taskPushType;
                        this.taskType = res.data.value.task.taskType;
                        this.theSql = res.data.value.task.theSql;
                        this.smsContent = res.data.value.task.smsContent;
                        this.wxAction = res.data.value.task.wxAction;
                        this.chanId = res.data.value.task.chanId;
                        this.firstExecTime = res.data.value.task.firstExecTime;
                        this.execPeriod = res.data.value.task.execPeriod;
                        this.firstFetchUserTime = res.data.value.task.firstFetchUserTime;
                        this.fetchUserPeriod = res.data.value.task.fetchUserPeriod;
                        if(this.theSql != null){
                            this.addSQLTemplateShow = true;
                            this.addUserGroupShow = false;
                        }
                        if(this.smsContent != null){
                            this.addSmsContentShow = true;
                            this.addWxActionContentShow = false;
                        } else if(this.wxAction != null){
                            this.addSmsContentShow = false;
                            this.addWxActionContentShow = true;
                        }
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            }
        },
        addOneRow(item, index){
            //规则初始化
            let rule = {
                tagId: item.id,
                tagName: item.name,
                tagUnit: item.unit,
                groupId: this.group.groupId,
                ruleType: 0,
                tagType: item.type,
                status: 1,
                remark: item.remark
            };
            // if(item.type==5||item.type==1){
            //     rule.ruleValue=''
            // }
            // if(item.type==2){
            //     rule.ruleValue=new Date()
            // }
            // if(item.type==3||item.type==4){
            //     rule.ruleValue=0
            // }
            let ruleOption={rule:rule,optionList:item.tagOptionList,selectName:''};
            console.log(ruleOption);
            this.ruleOptionList.push(ruleOption);
            // if (item.type === 5) {
            //     this.formInline.tagId = item.id;
            //     this.formInline.type = item.type;
            // }
        },
        tagChange(row){

        },
        pushTypeChange(value){
            if(value == 'REGULAR'){
                this.sendByMallAction = false;
                this.sendByRegular = true;
            } else if(value == 'MALL_TRIGGER'){
                this.sendByMallAction = true;
                this.sendByRegular = false;
            } else if(value == 'MANUAL'){
                this.sendByMallAction = false;
                this.sendByRegular = false;
            }
        },
        saveTask(){
            //判断合法
            saveTaskApiNew({
                taskId : this.taskId,
                taskName : this.taskName,
                taskDesc : this.taskDesc,
                activeNo : this.activeNo,
                taskPushType : this.taskPushType,
                taskType : this.taskType,
                theSql : this.theSql,
                channelTemplateNo : this.channelTemplateNo,
                smsContent : this.smsContent,
                wxAction : this.wxAction,
                chanId : this.chanId,
                firstExecTime : this.firstExecTime,
                execPeriod : this.execPeriod,
                firstFetchUserTime : this.firstFetchUserTime,
                fetchUserPeriod : this.fetchUserPeriod
            }).then((res) => {
                if (res.data.success) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            });
        },
        returnHistory(){
            this.$router.push({path:'/task',name: 'task'})
        }
        /*setVipDay(){
            let _this = this;
            // this.form.startTime = Date.parse(this.form.startTime);
            // this.form.endTime = Date.parse(this.form.endTime);
            setVipDayInfo(this.form).then((res) => {
                if(res.data.status==200){
                    _this.$message({
                        showClose: true,
                        message: '成功',
                        type: 'success'
                    });
                }else{
                    _this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                    });
                }
            })
        }*/
    }
}
</script>
<style>
.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}
.clearfix:after {
    clear: both
}

.box-card {
    margin: 13px 10px 10px 13px;
}
.el-page-header__left{
    align-items: center;
}
.el-page-header__content{
    flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/views/push/TaskEdit.vue